import { render, staticRenderFns, recyclableRender, components } from "./riskReporting.vue?vue&type=template&id=f1e08674&scoped=true&"
var renderjs
import script from "./riskReporting.vue?vue&type=script&lang=js&"
export * from "./riskReporting.vue?vue&type=script&lang=js&"
import style0 from "./riskReporting.vue?vue&type=style&index=0&id=f1e08674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e08674",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/riskReporting/riskReporting.vue"
export default component.exports